import styled from "@emotion/styled";
import { Box, BoxProps } from "@mui/material";

export const Container: React.FC<BoxProps> = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  width: 100%;
  height: 4rem;
  background-color: ${(p) => p.theme.navbar.colors.background};
  box-shadow: ${(p) => p.theme.shadows.primary};

  ${(p) => p.theme.media.mobileDown} {
    padding: 0.5rem 1rem;
    height: 3.5rem;
  }

  a {
    text-decoration: none;
    color: ${(p) => p.theme.navbar.colors.text};
  }

  ul {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 0.5rem;
      font-size: ${(p) => p.theme.text.fontSizes.xl};
      color: ${(p) => p.theme.navbar.colors.text};
      cursor: pointer;
      transition: all 0.2s ease-in-out;

      span {
        font-size: ${(p) => p.theme.text.fontSizes.m};
      }

      &:not(:last-child) {
        margin-right: 1rem;
      }

      &:hover {
        opacity: 0.7;
      }
    }
  }
`;

export const Logo = styled.span<{ $imgHeight?: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(p) => p.theme.navbar.colors.text};
  transition: opacity 200ms;

  img {
    height: ${(p) => p.$imgHeight ?? "24px"};
  }

  a {
    display: inline-flex;
    align-items: center;
    color: ${(p) => p.theme.navbar.colors.text};
    font-size: ${(p) => p.theme.text.fontSizes.xl};
    line-height: 100%;
  }
`;
